import { render, staticRenderFns } from "./BadgeLink.vue?vue&type=template&id=a07b9da6&"
import script from "./BadgeLink.vue?vue&type=script&lang=js&"
export * from "./BadgeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports